import { createFileRoute } from "@tanstack/react-router";
import AdminLmsListPage from "@/pages/admin/lms/list";

export const Route = createFileRoute("/app/admin/lms/")({
  component: AdminLmsListPage,
});
